import { ApplicationState } from 'application/redux';
import { connect } from 'react-redux';
import { changePageSize } from "../pagination-optimized/redux/actions";
import ItemsPerPageComponent from './items-per-page-component';


const mapStateToProps = (state: ApplicationState) => ({
  t: state.i18n.t,
  pagination: state.pagination.pagination
});

export default connect(mapStateToProps, {
  changePageSize
})(ItemsPerPageComponent);